import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { useEffect, useState } from 'react';
import LeaveService from '../../services/LeaveService';
import Grid from "@material-ui/core/Grid";
import { makeStyles } from "@material-ui/core/styles";
import { Alert, AlertTitle, Typography } from '@mui/material';
import Spacer from '../../components/Spacer';
import { CircularProgress } from "@material-ui/core";
import { styled } from '@mui/material/styles';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';

const useStyles = makeStyles((theme) => ({
  seeMore: {
    marginTop: theme.spacing(3),
  },
  btnAnnulerDialog: {
    background: "red",
    color: "white",
  },
  btnValiderDialog: {
    background: "rgb(19, 62, 103)",
    color: "white",
  },
  label: {
    fontWeight: "bold",
  },
  id: {
    color: "#3f51b5",
    fontWeight: "bold",
  },
  actualBalance: {
    textAlign: "right",
    margin: "auto"
  },
  detail: {
    fontSize: "13px"
  },
  divDetail: {
    justifyContent: "center"
  }
}));

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}));

export default function ConfirmationDialog(props) {
  const classes = useStyles();
  const openDialog = props.openDialog;
  const messageDialog = props.messageDialog;
  const closeDialog = props.closeDialog;
  const confirmDialog = props.confirmDialog;
  const cancelDialog = props.cancelDialog;
  const isParametrage = props.isCountFactParam ? true : false;
  const isCancel = props.isCancel;
  const leave_id = props.idLeave;
  const isPlanning = props.isPlanning;
  const confirmLeaveAdd = props.confirmLeaveAdd;
  const handleJustePlanningDialog = props.handleJustePlanningDialog;
  const handleValidateLeaveDialog = props.handleValidateLeaveDialog;
  const loadingPlanning = props.loadingPlanning;
  const loadingValidate = props.loadingValidate;
  const isValidatorNumberConfigurate = props.isValidatorNumberConfigurate;
  const dayOffNumberWithoutValidation = props.dayOffNumberWithoutValidation;
  const dayOffRequested = props.dayOffRequested;
  const openDialogueerreur = props.openDialogueerreur;
  const handleClose = props.handleClose;

  const [duration, setduration] = useState("");
  const [realDuration, setRealDuration] = useState("");
  const [beginMoment, setBeginMoment] = useState("");
  const [endMoment, setEndMoment] = useState("");
  const [leavecode, setLeavecode] = useState("");
  const [nomprenom, setNomprenom] = useState("");
  const [listvalidateur, setListValidateur] = useState([]);

  useEffect(() => {
    if (leave_id !== 0) {
      LeaveService.getLeaveById(leave_id).then((res) => {
        if (res && res.status) {
          setLeavecode(res.data.leave_code);
          setNomprenom(`${res.data.last_name + " " + res.data.first_name}`);
          setBeginMoment(res.data.date_start);
          setEndMoment(res.data.date_end);
          setRealDuration(res.data.duration);
          setduration(0);
        }
      });
    }
    LeaveService.listvalidateur().then((res) => {
      if (res && res.status) {
        setListValidateur(res.data);
      }
    });
  }, [leave_id]); // ✅ Tableau de dépendances correct

  return (
    <div>
      <Dialog open={openDialog} onClose={closeDialog} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
        <DialogTitle id="form-dialog-title" color="primary">
          {(isCancel && !isPlanning) ? "Annulation demande de congé" : ((isCancel && isPlanning) ? "Annulation planification" : "Confirmation")}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {(!isCancel && !isPlanning && !confirmLeaveAdd) && messageDialog}
            {((isCancel && !isPlanning && !confirmLeaveAdd) || isPlanning) &&
              <Grid container justifyContent="center" spacing={2}>
                <Grid item xs={12}>
                  <Alert severity="info">
                    <AlertTitle>Info</AlertTitle>
                    L'annulation d'un congé revient à une demande avec <strong> 0 nombre de jour demandé</strong>.
                    Voir détails ci-après:
                  </Alert>
                </Grid>
                <Grid container item spacing={2} className={classes.detail} xs={8}>
                  <Grid item xs={5}>
                    <label className={classes.id}>Identification:</label>
                  </Grid>
                  <Grid item xs={7}>
                    <label className={classes.id}>{leavecode}</label>
                  </Grid>

                  <Grid item xs={5}>
                    <label className={classes.label}>Nom et Prénom:</label>
                  </Grid>
                  <Grid item xs={7}>
                    <label className={classes.label1}>{nomprenom}</label>
                  </Grid>

                  <Grid item xs={5}>
                    <label className={classes.label}>Date de Départ:</label>
                  </Grid>
                  <Grid item xs={7}>
                    <label className={classes.label1}>{beginMoment}</label>
                  </Grid>

                  <Grid item xs={5}>
                    <label className={classes.label}>Date de retour:</label>
                  </Grid>
                  <Grid item xs={7}>
                    <label className={classes.label1}>{endMoment}</label>
                  </Grid>

                  <Grid item xs={5}>
                    <label className={classes.label}>Jour demandé :</label>
                  </Grid>

                  <Grid item xs={7}>
                    <label className={classes.label1}>{realDuration}</label>
                  </Grid>

                  <Grid item xs={5}>
                    <label className={classes.label}>Jour demandé après confirmation annulation:</label>
                  </Grid>

                  <Grid item xs={7}>
                    <label className={classes.label1}>{duration}</label>
                  </Grid>
                </Grid>
                <Grid item xs={7}>
                  <div style={{ textAlign: "center" }}>Confirmez-vous votre action?</div>
                </Grid>
              </Grid>
            }

            {(!isCancel && !isPlanning && confirmLeaveAdd) &&
              <>
                {isValidatorNumberConfigurate && dayOffRequested <= dayOffNumberWithoutValidation &&
                  <span>Dans le cadre d'une configuration spéciale sans validation associée à votre compte,
                    vous avez la possibilité de le valider directement, ce qui déclenchera l'envoi automatique d'une notification aux équipes des ressources humaines.<br /><br /> Voulez-vous le valider directement ou c'est juste un planning?</span>
                }

                {isValidatorNumberConfigurate && dayOffRequested > dayOffNumberWithoutValidation &&
                  <span> Dans le cadre d'une configuration spéciale sans validation associée à votre compte,
                    cette demande de congé sera envoyé pour validation de votre supérieur hierarchique.
                    <br /><br /> Voulez-vous l'envoyer directement à votre
                    supérieur hiérarchique pour demander sa validation ou c'est juste un planning?</span>
                }

                {!isValidatorNumberConfigurate &&
                  <>
                    <span>Voulez-vous l'envoyer directement à votre supérieur hiérarchique pour demander sa validation ou c'est juste un planning? </span>
                    <br />
                    <span>Voici la liste des validateurs pour votre demande de congé :</span>
                    <span>
                      <ul>
                        {listvalidateur.map((ts, index) => (
                          <li key={index}>{ts.nom}</li>
                        ))}
                      </ul>
                    </span>
                    <span>Acceptez-vous ces validateurs pour votre demande de congé ?</span>
                  </>
                }
              </>
            }
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          {!confirmLeaveAdd &&
            <>
              <Button variant="contained" color="primary" onClick={confirmDialog} >{isParametrage ? "OK" : "CONFIRMER"}</Button>
              {!isParametrage && <Button variant="contained" color="secondary" onClick={cancelDialog} >Annuler</Button>}
            </>
          }
          {confirmLeaveAdd &&
            <>
              {!isParametrage && <Button variant="contained" color="secondary" onClick={cancelDialog} disabled={(loadingPlanning || loadingValidate) ? true : false}>Retour</Button>}
              <Button
                style={loadingValidate ? { backgroundColor: "#F0F0F0", color: "#000000" } : { backgroundColor: "rgb(106, 207, 246)", color: "#FFFFFF" }}
                variant="contained"
                color="primary"
                onClick={handleJustePlanningDialog}
                disabled={(loadingValidate) ? true : false} >{loadingPlanning ? <CircularProgress /> : "Juste un planning"}</Button>

              <Button
                style={loadingPlanning ? { backgroundColor: "#F0F0F0", color: "#000000" } : { backgroundColor: 'rgb(19, 62, 103)', color: "#FFFFFF" }}
                variant="contained"
                color="primary"
                onClick={handleValidateLeaveDialog}
                disabled={(loadingPlanning) ? true : false}>{loadingValidate ? <CircularProgress /> : (isValidatorNumberConfigurate && dayOffRequested <= dayOffNumberWithoutValidation) ? "Valider" : "Envoyer pour validation"}</Button>
            </>
          }
        </DialogActions>
      </Dialog>
      <>
        <BootstrapDialog
          onClose={handleClose}
          aria-labelledby="customized-dialog-title"
          open={openDialogueerreur}
        >
          <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
            Solde de congés insuffisant
          </DialogTitle>
          <IconButton
            aria-label="close"
            onClick={handleClose}
            sx={(theme) => ({
              position: 'absolute',
              right: 8,
              top: 8,
              color: theme.palette.grey[500],
            })}
          >
            <CloseIcon />
          </IconButton>
          <DialogContent dividers>
            <Typography gutterBottom>
              Votre demande de congés ne peut pas être validée car elle entraînerait un solde de congés négatif.
            </Typography>
            <Typography gutterBottom>
              Veuillez vérifier votre solde restant et ajuster votre demande en conséquence.
            </Typography>
            <Typography gutterBottom>
              Veuillez enregistrer seulement en tant que planning.
            </Typography>
          </DialogContent>
          <DialogActions>
            <Button autoFocus onClick={handleClose}>
              D'accord, compris
            </Button>
          </DialogActions>
        </BootstrapDialog>
      </>
    </div>
  );
}